import { AgentFormSectionId } from "routes/agents/agent-form/constants";

type SectionId = AgentFormSectionId;

export const scrollToSection = (sectionId: SectionId): void => {
  const element = document.getElementById(sectionId);

  if (element) element.scrollIntoView({ behavior: "smooth" });
};
